/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 43f96b2d (Wed Dec  3 21:51:26 UTC 2025)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  PaginationResponse,
  PaginationResponseFromJSON,
  PaginationResponseToJSON,
  UserScreeningRecord,
  UserScreeningRecordFromJSON,
  UserScreeningRecordToJSON,
} from './'

/**
 *
 * @export
 * @interface FetchUserScreeningsResponse
 */
export interface FetchUserScreeningsResponse {
  /**
   * The records of the userScreening available.
   * @type {Array<UserScreeningRecord>}
   * @memberof FetchUserScreeningsResponse
   */
  data: Array<UserScreeningRecord>
  /**
   *
   * @type PaginationResponse
   * @memberof FetchUserScreeningsResponse
   */
  pagination?: PaginationResponse
}

export function FetchUserScreeningsResponseFromJSON(
  json: any
): FetchUserScreeningsResponse {
  return FetchUserScreeningsResponseFromJSONTyped(json, false)
}

export function FetchUserScreeningsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchUserScreeningsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    data: (json['data'] as Array<any>).map(UserScreeningRecordFromJSON),
    pagination: !exists(json, 'pagination')
      ? undefined
      : PaginationResponseFromJSON(json['pagination']),
  }
}

export function FetchUserScreeningsResponseToJSON(
  value?: FetchUserScreeningsResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    data: (value.data as Array<any>).map(UserScreeningRecordToJSON),
    pagination: PaginationResponseToJSON(value.pagination),
  }
}
